import React, { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import {
  FormHelperText,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
  Box,
  Typography,
  Stack,
} from "@mui/material";

import { MaskCelulares } from "app/modules/shared/mask/mascarasInputs";

import AcceptServiceresponse from "app/modules/shared/components/AcceptServiceresponse";
import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";
import { StyleInputs } from "../styles/themes";

import SkeletonForm from "app/modules/common/components/Skeleton/SkeletonForm";
import {
  validarCelular,
  validarFalsaData,
} from "app/modules/shared/validations/validaciones";

import {
  consultaRefPersonal,
  crearClienteRefePersonales,
} from "../services/clienteService";

import { ERROR_VALIDACION_CONTACTO } from "app/modules/shared/constants/constantsMessanges";
import SelectItemsCatalogs from "app/modules/common/components/Selector";

import "../styles/main.css";
import { useSelector } from "react-redux";

const FormReferenciasCliente = ({ idCliente, setInfoClienteGrabada }) => {
  const { authUser } = useSelector(({ auth }) => auth);

  const [referenciasXCliente, setReferenciasXCliente] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [idReferenciaPersonalAux, setIdReferenciaPersonalAux] = useState(0);
  const [idReferenciaFamiliarAux, setIdReferenciaFamiliarAux] = useState(0);

  const [datosEnviadosCorrectamente, setDatosEnviadosCorrectamente] =
    useState(false);

  useEffect(() => {
    const getData = async () => {
      try {
        const informacionRefPersonal = await consultaRefPersonal(idCliente);

        if (informacionRefPersonal.state) {
          arrayModificadoReferencias(informacionRefPersonal.data);
        } else {
          setReferenciasXCliente([]);
          setIsLoading(false);
        }
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };

    getData();
  }, []);

  if (isLoading) {
    return <SkeletonForm />;
  }

  function arrayModificadoReferencias(referenciasCliente) {
    if (referenciasCliente.length === 0) {
      setReferenciasXCliente({
        idCliente1: idCliente,
        idReferenciaPersona1: 0,
        nombreReferencia1: "",
        esPersonal1: false,
        celular1: "",

        idCliente2: idCliente,
        idReferenciaPersona2: 0,
        nombreReferencia2: "",
        esPersonal2: true,
        celular2: "",
      });
      setIsLoading(false);
    } else if (referenciasCliente.length === 1) {
      setIdReferenciaPersonalAux(referenciasCliente[0].idReferenciaPersonal);
      console.log(referenciasCliente[0].idReferenciaPersonal);
      setReferenciasXCliente({
        idCliente1: referenciasCliente[0].idCliente || "",
        idReferenciaPersonal1: idReferenciaPersonalAux,
        nombreReferencia1: referenciasCliente[0].nombreReferencia || "",
        esPersonal1: false,
        celular1: referenciasCliente[0].celular || "",

        idCliente2: idCliente,
        idReferenciaPersonal2: 0,
        nombreReferencia2: "",
        esPersonal2: true,
        celular2: "",
      });
      setIsLoading(false);
    } else {
      setIdReferenciaPersonalAux(referenciasCliente[0].idReferenciaPersonal);
      setIdReferenciaFamiliarAux(referenciasCliente[1].idReferenciaPersonal);
      setReferenciasXCliente({
        idCliente1: referenciasCliente[0].idCliente || "",
        idReferenciaPersonal1: idReferenciaPersonalAux,
        nombreReferencia1: referenciasCliente[0].nombreReferencia || "",
        esPersonal1: false,
        celular1: referenciasCliente[0].celular || "",

        idCliente2: referenciasCliente[1].idCliente || "",
        idReferenciaPersonal2: idReferenciaFamiliarAux,
        nombreReferencia2: referenciasCliente[1].nombreReferencia || "",
        esPersonal2: true,
        celular2: referenciasCliente[1].celular || "",
      });
      setIsLoading(false);
    }
  }

  const configuracionDatosEnvio2 = async (valores, setSubmitting) => {
    setSubmitting(true);

    const today = new Date().toLocaleString("en-US");
    const arrayReferenciasCliente = [
      {
        idCliente: Number(valores.idCliente1),
        idReferenciaPersonal: Number(idReferenciaPersonalAux),
        nombreReferencia: valores?.nombreReferencia1?.toUpperCase() ?? "",
        // parentesco: valores.parentesco1,
        esPersonal: false,
        celular: valores.celular1,
        esActivo: true,

        fechaCreacion: today,
        usuarioCreacion: authUser.key,
        estacionCreacion: authUser.estacion,
      },
      {
        idCliente: Number(valores.idCliente2),
        idReferenciaPersonal: Number(idReferenciaFamiliarAux),
        nombreReferencia: valores?.nombreReferencia2?.toUpperCase() ?? "",
        // parentesco: valores.parentesco2,
        esPersonal: true,
        celular: valores.celular2,
        esActivo: true,

        fechaCreacion: today,
        usuarioCreacion: authUser.key,
        estacionCreacion: authUser.estacion,
      },
    ];

    try {
      const arrayPromesasReferencias = arrayReferenciasCliente?.map(
        (referencias) => {
          return crearClienteRefePersonales(referencias);
        },
      );

      const respuestaReferenciasCliente = await Promise.all(
        arrayPromesasReferencias,
      );

      if (
        respuestaReferenciasCliente.every(
          (respuestaRef) => respuestaRef.state === true,
        )
      ) {
        if (setInfoClienteGrabada) {
          setInfoClienteGrabada((args) => ({
            ...args,
            referencias: true,
          }));
        }
        setIdReferenciaPersonalAux(respuestaReferenciasCliente[0].data);
        setIdReferenciaFamiliarAux(respuestaReferenciasCliente[1].data);
        setDatosEnviadosCorrectamente(true);

        setTimeout(() => {
          setSubmitting(false);
          setDatosEnviadosCorrectamente(false);
        }, 1000);
      } else {
        setSubmitting(false);
      }
    } catch (error) {
      console.log(error);
      setSubmitting(false);
    } finally {
      setSubmitting(false);
    }
  };

  const MasInformacionReferenciaFamiliar = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 1,
          p: 1,
          width: "100%",
        }}
      >
        <Typography variant="p" color="text.secondary">
          Ingresa los datos de un familiar cercano (padre, madre, hermano/a)
          No puede ser tu Cónyuge .
        </Typography>
      </Box>
    );
  };
  const MasInformacionReferenciaPersonal = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 1,
          p: 1,
          width: "100%",
        }}
      >
        <Typography variant="p" color="text.secondary">
          Registra a una persona de confianza o un familiar (No Cónyuge). 
        </Typography>
      </Box>
    );
  };

  return (
    <Formik
      initialValues={referenciasXCliente}
      enableReinitialize={true}
      validate={async (values) => {
        const errors = {};

        /* errores referencia familiar */
        if (!/^[a-zA-ZÑñ" "]{0,50}$/.test(values.nombreReferencia1)) {
          errors.nombreReferencia1 =
            "El nombre no debe sobrepasar los 50 caracteres.";
        }
        if (await validarFalsaData(values.celular1, "CEL")) {
          errors.celular1 = ERROR_VALIDACION_CONTACTO;
        }

        if (!/^[0-9]{0,11}$/.test(values.celular1)) {
          errors.celular1 = "Solo se aceptan números";
        }
        if (validarCelular(values.celular1)) {
          errors.celular1 = "Primer digito debería ser '09'";
        }

        /* errores referencia personal */
        if (!/^[a-zA-ZÑñ" "]{0,50}$/.test(values.nombreReferencia2)) {
          errors.nombreReferencia2 =
            "El nombre no debe sobrepasar los 50 caracteres.";
        }
        if (await validarFalsaData(values.celular2, "CEL")) {
          errors.celular2 = ERROR_VALIDACION_CONTACTO;
        }

        if (!/^[0-9]{0,11}$/.test(values.celular2)) {
          errors.celular2 = "Solo se aceptan números";
        }
        if (validarCelular(values.celular2)) {
          errors.celular2 = "Primer digito debería ser '09'";
        }

        return errors;
      }}
      validationSchema={Yup.object({
        nombreReferencia1: Yup.string()
          .max(50, "Debería tener máximo 50 caracteres")
          .min(3, "Debería tener al menos 3 caracteres")
          .required("Nombre y Apellido requerido"),
        // parentesco1: Yup.string().required("Parentesco requerido"),
        celular1: Yup.string()
          .min(10, "Debería tener 10 números")
          .max(10, "Debería tener 10 números")
          .required("Celular requerido"),

        nombreReferencia2: Yup.string()
          .max(50, "Debería tener máximo 50 caracteres")
          .min(3, "Debería tener al menos 3 caracteres")
          .required("Nombre y Apellido requerido"),
        // parentesco2: Yup.string().required("Parentesco requerido"),
        celular2: Yup.string()
          .min(10, "Debería tener 10 números")
          .max(10, "Debería tener 10 números")
          .required("Celular requerido"),
      })}
      onSubmit={(values, { setSubmitting }) => {
        configuracionDatosEnvio2(values, setSubmitting);
      }}
    >
      {({
        values,
        handleChange,
        touched,
        errors,
        handleBlur,
        isSubmitting,
      }) => (
        <Form>
          {/* Referencia Personal */}
          <SCSAccordion
            tituloCabecera={`Referencia Familiar`}
            tieneInfo={true}
            componenteInformacion={<MasInformacionReferenciaFamiliar />}
          >
            <Stack
              direction={{ xs: "column", sm: "column", md: "row" }}
              spacing={3}
              justifyContent={"space-around"}
              alignItems={"center"}
            >
              <TextField
                id="nombreReferencia1"
                name="nombreReferencia1"
                type="text"
                label="Nombre y Apellido"
                sx={StyleInputs(40, 80)}
                value={values.nombreReferencia1}
                onChange={handleChange}
                size="small"
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={
                  touched.nombreReferencia1 && Boolean(errors.nombreReferencia1)
                }
                helperText={
                  touched.nombreReferencia1 && errors.nombreReferencia1
                }
                onBlur={handleBlur}
              />
              {/* <Box>
                <SelectItemsCatalogs
                  pais="ECU"
                  especial="false"
                  catalogos="PARENTESCO"
                  grupo={1}
                  name="parentesco1"
                  labelName="Parentesco"
                  componentSize={{ pcWidth: 65, phoneWidth: 65 }}
                  handleBlur={handleBlur}
                  touched={touched}
                  errors={errors}
                />
              </Box> */}

              <Box>
                <FormControl
                  // sx={{ ...StyleInputs(18, 45) }}
                  size="small"
                  variant="outlined"
                  error={touched.celular1 && Boolean(errors.celular1)}
                  helperText={touched.celular1 && errors.celular1}
                  onBlur={handleBlur}
                >
                  <InputLabel htmlFor="celular1">Celular</InputLabel>
                  <OutlinedInput
                    value={values.celular1}
                    onChange={handleChange}
                    name="celular1"
                    id="celular1"
                    inputComponent={MaskCelulares}
                    label="celular1"
                  />
                  <ErrorMessage
                    name="celular1"
                    component={() => (
                      <FormHelperText>{errors.celular1}</FormHelperText>
                    )}
                  />
                </FormControl>
              </Box>
            </Stack>
          </SCSAccordion>

          {/* Referencia Personal */}
          <SCSAccordion
            tituloCabecera={`Referencia Personal o Familiar`}
            tieneInfo={true}
            componenteInformacion={<MasInformacionReferenciaPersonal />}
          >
            <Stack
              direction={{ xs: "column", sm: "column", md: "row" }}
              spacing={3}
              justifyContent={"space-around"}
              alignItems={"center"}
            >
              <TextField
                id="nombreReferencia2"
                name="nombreReferencia2"
                type="text"
                label="Nombre y Apellido"
                sx={StyleInputs(40, 80)}
                value={values.nombreReferencia2}
                onChange={handleChange}
                size="small"
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={
                  touched.nombreReferencia2 && Boolean(errors.nombreReferencia2)
                }
                helperText={
                  touched.nombreReferencia2 && errors.nombreReferencia2
                }
                onBlur={handleBlur}
              />
              {/* <Box>
                <SelectItemsCatalogs
                  pais="ECU"
                  especial="false"
                  catalogos="PARENTESCO"
                  grupo={1}
                  name="parentesco2"
                  labelName="Parentesco"
                  componentSize={{ pcWidth: 65, phoneWidth: 65 }}
                  handleBlur={handleBlur}
                  touched={touched}
                  errors={errors}
                />
              </Box> */}

              <Box>
                <FormControl
                  //sx={StyleInputs(15, 45)}
                  size="small"
                  variant="outlined"
                  error={touched.celular2 && Boolean(errors.celular2)}
                  helperText={touched.celular2 && errors.celular2}
                  onBlur={handleBlur}
                >
                  <InputLabel htmlFor="celular2">Celular</InputLabel>
                  <OutlinedInput
                    value={values.celular2}
                    onChange={handleChange}
                    name="celular2"
                    id="celular2"
                    inputComponent={MaskCelulares}
                    label="celular2"
                  />
                  <ErrorMessage
                    name="celular2"
                    component={() => (
                      <FormHelperText>{errors.celular2}</FormHelperText>
                    )}
                  />
                </FormControl>
              </Box>
            </Stack>

            <div className="confirmar-estados-servicios">
              <SCSLoadingButton loading={isSubmitting} titulo="GUARDAR" />

              {datosEnviadosCorrectamente && <AcceptServiceresponse />}
            </div>
          </SCSAccordion>
        </Form>
      )}
    </Formik>
  );
};

export default FormReferenciasCliente;
